import React from "react";
import { Box } from "@mui/material";

const LandingBackground = () => {
  return (
    <>
      {/* Soft blue top left */}
      <Box
        sx={{
          position: "absolute",
          top: "0px",
          left: "0px",
          width: "500px",
          height: "500px",
          borderRadius: "50%",
          background: "#b3d2fd",
          opacity: 0.6,
          filter: "blur(150px)",
          zIndex: 0,
        }}
      />

      {/* Soft orange top right */}
      <Box
        sx={{
          position: "absolute",
          top: "100px",
          right: "-250px",
          width: "700px",
          height: "700px",
          borderRadius: "50%",
          background: "#f8bbd0",
          opacity: 0.4,
          filter: "blur(160px)",
          zIndex: 0,
        }}
      />

      {/* Soft green middle left */}
      <Box
        sx={{
          position: "absolute",
          top: "800px",
          left: "-150px",
          width: "800px",
          height: "800px",
          borderRadius: "50%",
          background: "#c8e6c9",
          opacity: 0.4,
          filter: "blur(170px)",
          zIndex: 0,
        }}
      />

      {/* Soft pink middle right */}
      <Box
        sx={{
          position: "absolute",
          top: "1000px",
          right: "-200px",
          width: "600px",
          height: "600px",
          borderRadius: "50%",
          background: "#ffe0b2",
          opacity: 0.5,
          filter: "blur(140px)",
          zIndex: 0,
        }}
      />

      {/* Lower section repeats */}
      <Box
        sx={{
          position: "absolute",
          top: "1500px",
          left: "0px",
          width: "500px",
          height: "500px",
          borderRadius: "50%",
          background: "#b3d2fd",
          opacity: 0.6,
          filter: "blur(150px)",
          zIndex: 0,
        }}
      />
      <Box
        sx={{
          position: "absolute",
          top: "1600px",
          right: "-250px",
          width: "700px",
          height: "700px",
          borderRadius: "50%",
          background: "#f8bbd0",
          opacity: 0.4,
          filter: "blur(160px)",
          zIndex: 0,
        }}
      />
      <Box
        sx={{
          position: "absolute",
          top: "2300px",
          left: "-150px",
          width: "800px",
          height: "800px",
          borderRadius: "50%",
          background: "#c8e6c9",
          opacity: 0.4,
          filter: "blur(170px)",
          zIndex: 0,
        }}
      />
      <Box
        sx={{
          position: "absolute",
          top: "2500px",
          right: "-200px",
          width: "600px",
          height: "600px",
          borderRadius: "50%",
          background: "#ffe0b2",
          opacity: 0.5,
          filter: "blur(140px)",
          zIndex: 0,
        }}
      />
    </>
  );
};

export default LandingBackground;
